<template>
 <el-tabs v-model="activeName" @tab-click="handleClick">
  <el-tab-pane label="历史月流量" name="first">
    <el-form :model="queryParams"  :inline="true">
      <el-form-item  prop="dateRange">
          <el-date-picker
            format="yyyy-MM"
            value-format="yyyy-MM"
            v-model="dateRange"
            @change="search"
            type="monthrange"
            range-separator="-"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
          </el-date-picker>
        </el-form-item>
    </el-form>
    <div id="chart" :class="className" :style="{height:height,width:width}" />
  </el-tab-pane>
  <el-tab-pane label="运营商历史月流量" name="second" v-if="operationName!='国际' && checkPermi(['card:info:carrierMonthFlow'])">
    <el-button type="primary" :loading="loading" @click="refresh">{{loading?'加载中':'刷新'}}</el-button>
    <div id="carrierChart" :style="{height:height,width:width}" />
  </el-tab-pane>
 </el-tabs>
</template>

<script>
import * as echarts from "echarts"
import resize from '@/views/dashboard/mixins/resize'
import {lineChartCardFlow , carrierCardFlowMonth} from "@/api/api.js"; //卡流量数据
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    iccid: {
      type: String,
    },
    operationName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart:null,
      carrierChart:null,
      queryParams:{
        iccid:this.iccid,
        type:'2'
      },
      dateRange:[],
      activeName:'first',
      loading:false
    }
  },
  watch: {
    iccid() {
      this.queryParams.iccid = this.iccid
      this.initChart()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
      if(this.operationName!='国际' && this.checkPermi(['card:info:carrierMonthFlow'])){
        this.initCarrierChart()
      }
    })
  },
  beforeDestroy() {
    if (!!this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    if (!!this.carrierChart) {
      this.carrierChart.dispose()
      this.carrierChart = null
    }
    
  },
  methods: {
    handleClick(tab) {
      // if (tab.name == "second") {
      //   this.initCarrierChart()
      // }
      // if (tab.name == "first") {
      //   this.initChart()
      // }
    },
    refresh(){
      this.initCarrierChart()
    },
    initCarrierChart(){
      this.loading = true
      let that = this
      document.getElementById("carrierChart").style.width = (window.innerWidth / 7) * 5 + 'px';// 宽度
      this.carrierChart = echarts.init(document.getElementById("carrierChart"))
      if(!this.carrierChart ){
        return;
      }
      carrierCardFlowMonth(this.queryParams).then(res=>{
          that.loading = false
          if (that.carrierChart){
            that.setOptions(that.carrierChart,res.data.data);
            that.carrierChart.resize();
          }
      })
    },
    initChart() {
      // this.chart = echarts.init(this.$el)
      document.getElementById("chart").style.width = (window.innerWidth / 7) * 5 + 'px';// 宽度
      this.chart = echarts.init(document.getElementById("chart"))
      if(!this.chart ){
        return;
      }
      let that = this
      lineChartCardFlow(this.queryParams).then(res=>{
        if(that.chart){
          that.setOptions(that.chart,res.data.data);
          that.chart.resize();
        }
      })
    },
    setOptions(chart,{timeList,monthList}={}) {
      chart.setOption({
        title: {
          text: '流量统计',
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: [{
              name: this.iccid,
              // 设置文本为红色
              textStyle: {
                  color: 'red',
                  fontSize:16
              }
          }]
        },
        toolbox: {
          show: true,
          feature: {
            magicType: { show: true, type: ['line', 'bar'] },
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: timeList
          }
        ],
        yAxis: [
          {
            type: 'value',
            position: 'left',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#1890ff'
              }
            },
            axisLabel: {
              formatter: '{value} MB'
            }
          }
        ],
        series: [
          {
            name: this.iccid,
            type: 'bar',
            data: monthList,
            label: {
              show: true,
                position: "top",  // 展示在柱子的上方
                distance: 6,  //与柱子之间的距离
                fontSize: 14,  
                color: "#1890ff",
            }
          }
        ]
      });

    },
    // 搜索
    search() {
      let param = this.addDateRange(this.queryParams, this.dateRange)
      this.chart = echarts.init(document.getElementById("chart"))
      lineChartCardFlow(param).then(res=>{
          this.setOptions(this.chart,res.data.data)
      })
    },
  }
}
</script>
<style scoped lang="less">
.el-loading-mask {
  z-index: 2000; /* 根据需要调整 */
}
</style> 